import { Mid } from "../constants/mids";
import { getCvSplitAppliedDate } from "./isCvSplitApplied";
import { isAuOnlyClient } from "./auHelper";

export function getEntityMid(entity: { campaign_source: string; campaign_source_au?: string; original_campaign_source_au?: string; created_at: number; payment_mid?: Mid; products?: string }, product: string): Mid {

    // Australia-only clients have no Canada side — they always bill and brand as AUMG.
    // Deliberately not agent-gated: identity and billing must not depend on who is looking.
    if (isAuOnlyClient(entity)) {
        return Mid.AUMG;
    }

    const campaignSource = (entity.campaign_source || '').toLowerCase();

    product = (product || '').toLowerCase();

    const cutoffTimestamp = getCvSplitAppliedDate();
    
    // USA DV Product Check
    if(product.includes('usa dv') || campaignSource.includes('usa dv')) {
        
        // Make sure that other bought products are allowed, either 9.99$ or 'usa dv'
        const products = (entity.products || '').toLowerCase().split(',').map(product => product.trim());
        if(products && products.length > 1) {
            const allowedProducts = ['online interview meeting', 'canada online evaluation'];
            const isEachProductAllowed = products.every(p => allowedProducts.includes(p) || p.includes('usa dv'));

            if(isEachProductAllowed) {
                return Mid.USA_DV;
            }
        } else {
            return Mid.USA_DV;
        }
    }

    if(campaignSource.includes('mdc') && campaignSource.includes('bcn')) {
        return Mid.BCN_MDC;
    }

    if (entity.payment_mid) {
        if (entity.payment_mid === Mid.MDC) {
            return Mid.MDC;
        }

        if (entity.payment_mid === Mid.BCN) {
            return Mid.BCN;
        }

        if (entity.payment_mid === Mid.VDC) {
            return Mid.VDC;
        }
        
        if (entity.payment_mid === Mid.CMG) {
            return Mid.CMG;
        }

        if (entity.payment_mid === Mid.USA_DV) {
            return Mid.USA_DV;
        }

        if (entity.payment_mid === Mid.ACX) {
            return Mid.ACX;
        }

        if(entity.payment_mid === Mid.CV) { 
            return Mid.CV;
        }

        if(entity.payment_mid === Mid.AUMG) {
            return Mid.MDC;
        }
    }

    if (
        campaignSource.includes('mdc') &&
        entity.created_at !== null &&
        cutoffTimestamp &&
        (entity.created_at * 1000) <= cutoffTimestamp
    ) {
        return Mid.CV;
    }

    if (
        campaignSource.includes('mdc') &&
        entity.created_at !== null &&
        cutoffTimestamp &&
        (entity.created_at * 1000) > cutoffTimestamp &&
        (
            entity.payment_mid === Mid.MDC || entity.payment_mid === Mid.USA_DV || !entity.payment_mid
        )
    ) {
        return Mid.MDC;
    }

    if (campaignSource.includes('cmg')) {
        return Mid.CMG;
    }

    if(campaignSource.includes('bcn')) {
        return Mid.BCN;
    }

    if (campaignSource.includes('vdc')) {
        return Mid.VDC;
    }

    if (campaignSource.includes('acx')) {
        return Mid.ACX;
    }

    if (cutoffTimestamp && Date.now() >= cutoffTimestamp) {
        return Mid.CV;
    }

    return Mid.CV;
}